import { type DependencyList, type EffectCallback } from "react"
import { usePreviousTyped } from "~Shared/hooks/common.hooks"

/**
 * @param effectCallback the useEffect callback.
 * @param dependencies deps array
 * @param dependencyNames (optional) dependency names array for naming properties of the changedDeps prop.
 * @param customHook any custom hook you want to run instead of the default useEffect.
 */
export const useChangeEffect = (
    effectCallback: (changedDeps: any) => any,
    dependencies: any,
    dependencyNames: Array<string> = [],
    customHook: (effect: EffectCallback, deps?: DependencyList) => void,
) => {
    const previousDeps = usePreviousTyped(dependencies, [])

    const changedDeps: any = {}
    for (let i = 0; i < dependencies.length; i++) {
        if (dependencies[i] !== previousDeps[i]) {
            const keyName = dependencyNames[i] || i
            changedDeps[keyName] = { previousValue: previousDeps[i], currentValue: dependencies[i] }
        }
    }
    customHook(() => effectCallback(changedDeps), dependencies)
}
